<template>
    <section>
        <transition-group name="modal">
            <ModalBrand v-if="brand" key="brand"></ModalBrand>
            <ModalZone v-if="zone" key="zone"></ModalZone>
            <ModalCampaign v-if="campaign" key="campaign"></ModalCampaign>
        </transition-group>
    </section>
</template>

<script>
import ModalZone from "./ModalZone";
import ModalBrand from "./ModalBrand";
import ModalCampaign from "./ModalCampaign";

export default {
    components: {
        ModalZone,
        ModalBrand,
        ModalCampaign
    },
    props: ["brand", "zone", "campaign"]
};
</script>



// WEBPACK FOOTER //
// modal.vue?26fd1730